export default __webpack_public_path__ + "static/media/3fcd9cf2361f5ffd0e5851b19721d403.c2203a85.gif";